import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import TimeAgo from 'react-timeago'
import defaultFormatter from 'react-timeago/lib/defaultFormatter'

import donationAmount from 'src/flp/donations/donationAmount'

const Donation = ({ order }) =>
  <div className="d-flex align-items-center gap-3">
    <div>{/* wrap to prevent flex from squishing the initials */}
      <div className="initials">
        {
          (order.has_business_name || order.anonymized) ?
          <FontAwesomeIcon icon={faHeart} /> :
          order.donor_initials
        }
      </div>
    </div>
    <div className="h6 fw-normal mb-0">
      <b>{order.donor_name}</b>
      <span className="text-body-secondary"> donated </span>
      <span className="text-nowrap">
        <b>{donationAmount(order)}</b>
        {
          order.currency.iso_code != 'USD' ?
          <small className="text-body-secondary"> {order.currency.iso_code}</small>
          : null
        }
      </span>
      <br />
      <small className="me-n2">
        <span className="me-2">
          <TimeAgo
            date={order.created_at}
            formatter={(value, unit, suffix) =>
              unit == 'second'
              ? 'less than a minute ago'
              : defaultFormatter(value, unit, suffix)
            }
          />
          {
            order.is_pending_pledge &&
            <span className="text-primary"> (pending)</span>
          }
        </span>
        {
          order.is_match &&
          <span className="me-2 text-primary text-nowrap">
            Match 🎉
          </span>
        }
      </small>
    </div>
  </div>

export default Donation
